import type { FaireProductEntity } from "../../entity_types/product";

export const p_kuuxswrvwc: FaireProductEntity = {
  token: "p_kuuxswrvwc",
  type: "product",
  name: "Mommy and Me Matching Heather Classic Beanies [Kids]",
  brandToken: "b_gy33y47y5m",
  brandName: "Fashion City",
  imageUrl:
    "https://cdn.faire.com/fastly/8ac888d6f5f2f560c4f0e15dad66a25896a9df0a237d1e484b57e584b9bb0237.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a621c42e9995bd30517d547357e98452ace585fb5fe60864559cbbf6686e048.jpeg",
    "https://cdn.faire.com/fastly/9d457ad001ab9e0c1c63ec6ec4cbec7944b22463270274196aa8da3f932115ad.jpeg",
    "https://cdn.faire.com/fastly/085a6590ecb3b31f18bce3dc9b0a36392ac723e49e0063e2e8670125993943d0.jpeg",
    "https://cdn.faire.com/fastly/f17c9e6c45a883a55120d275c71ee7c7982a01a32f8f7e2b3e3623ff93e8ed3d.jpeg",
    "https://cdn.faire.com/fastly/1cee89de3501b2ec1deb455ff62f3e8302b23c09c2f625f05d786903d1d2b822.jpeg",
    "https://cdn.faire.com/fastly/045916497ea122b02a38ac28229e4a195fe24c5474dd6b07a7b350c23aacef0f.jpeg",
  ],
  priceDollars: 24.39,
  description:
    "Mommy and Me Matching Heather Classic Beanies [Kids]\n\n***Comes with 1 Adult Beanie+1 Kids Beanie***\n- Classic Knitted Solid Colored Design\n- 97% Recycled Polyester, 3% Spandex\n- Kids Hat (For 1 to 4 years old)\n",
  tags: [],
  msrpDollars: 73.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:57.137Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
